const AppVersion = () => {
    return <div id="app_version">Version 1.1.7</div>
}

export default AppVersion;